import { render, staticRenderFns } from "./SealPrefixWarning.vue?vue&type=template&id=1ebc0bc2"
import script from "./SealPrefixWarning.vue?vue&type=script&lang=js"
export * from "./SealPrefixWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports